/*
  Volltexte der Vorlagen — absatzweise.

  ACHTUNG: Sämtliche Inhalte sind erfunden. Es handelt sich weder um echte
  Verwaltungsvorlagen noch um echte nichtöffentliche Unterlagen. Die Texte sind
  fachlich plausibel gebaut, damit die Demo glaubwürdig wirkt, beschreiben aber
  keine reale Kommune und keinen realen Vorgang.

  Jeder Absatz hat eine feste Kennung (`id`). Markierungen im Dokument werden
  als Absatz-Kennung plus Zeichenbereich gespeichert. Deshalb dürfen bestehende
  Absatz-Kennungen nicht nachträglich geändert werden — sonst zeigen die
  gespeicherten Markierungen ins Leere. Siehe VEREINFACHUNGEN.md.

  art: "ueberschrift" | "absatz" | "aufzaehlung" | "hinweis"
*/

export const dokumente = {
  "datei-184": {
    id: "datei-184",
    vorlageId: "vl-184",
    seitenzahl: 42,
    seitenImText: 6,
    anlagenhinweis:
      "Seiten 7–42: Anlage 1 Planzeichnung, Anlage 2 Begründung, Anlage 3 Umweltbericht. In diesem Prototyp nicht hinterlegt.",
    absaetze: [
      { id: "d184-01", art: "ueberschrift", seite: 1, text: "Beschlussvorschlag" },
      {
        id: "d184-02",
        art: "absatz",
        seite: 1,
        text: "Der Bau- und Umweltausschuss beschließt, den Entwurf des Bebauungsplans Nr. 47 „Am Mühlenweg“ in der Fassung vom 12. Juni 2026 einschließlich Begründung und Umweltbericht gemäß § 3 Absatz 2 Baugesetzbuch für die Dauer eines Monats öffentlich auszulegen. Ort und Dauer der Auslegung sind ortsüblich bekannt zu machen.",
      },
      {
        id: "d184-03",
        art: "absatz",
        seite: 1,
        text: "Die Verwaltung wird beauftragt, parallel die Stellungnahmen der Behörden und sonstigen Träger öffentlicher Belange nach § 4 Absatz 2 Baugesetzbuch einzuholen.",
      },
      { id: "d184-04", art: "ueberschrift", seite: 1, text: "Sachverhalt" },
      {
        id: "d184-05",
        art: "absatz",
        seite: 1,
        text: "Das Plangebiet umfasst rund 4,2 Hektar am östlichen Ortsrand und wird begrenzt durch den Mühlenweg im Norden, die Feldstraße im Westen und die Bahnstrecke Ellernbach–Warkenbrück im Süden. Die Flächen werden derzeit überwiegend landwirtschaftlich genutzt. Der Flächennutzungsplan stellt den Bereich bereits als Wohnbaufläche dar; der Bebauungsplan wird damit aus dem Flächennutzungsplan entwickelt.",
      },
      {
        id: "d184-06",
        art: "absatz",
        seite: 2,
        text: "Vorgesehen ist die Festsetzung eines allgemeinen Wohngebiets nach § 4 Baunutzungsverordnung mit rund 85 Wohneinheiten in Einzel-, Doppel- und Reihenhäusern sowie drei Mehrfamilienhäusern entlang der Feldstraße. Für die Mehrfamilienhäuser sind drei Vollgeschosse zulässig, für die übrige Bebauung zwei Vollgeschosse zuzüglich ausgebautem Dachgeschoss.",
      },
      {
        id: "d184-07",
        art: "absatz",
        seite: 2,
        text: "Mindestens 30 Prozent der Wohnfläche in den Mehrfamilienhäusern sind für den öffentlich geförderten Wohnungsbau vorzusehen. Diese Quote wird über einen städtebaulichen Vertrag mit dem Vorhabenträger abgesichert und ist Voraussetzung für den Satzungsbeschluss.",
      },
      { id: "d184-08", art: "ueberschrift", seite: 2, text: "Erschließung und ruhender Verkehr" },
      {
        id: "d184-09",
        art: "absatz",
        seite: 2,
        text: "Die verkehrliche Erschließung erfolgt vollständig über den Mühlenweg. Das Verkehrsgutachten des Büros Prenzel + Partner vom 4. April 2026 prognostiziert für den Endausbau rund 420 zusätzliche Kraftfahrzeugfahrten je Werktag. Die vorhandene Knotenpunktleistungsfähigkeit an der Einmündung Mühlenweg / Bahnhofstraße bleibt danach auch in der Spitzenstunde ausreichend.",
      },
      {
        id: "d184-10",
        art: "absatz",
        seite: 3,
        text: "Für den ruhenden Verkehr wird ein Stellplatzschlüssel von 1,5 Stellplätzen je Wohneinheit festgesetzt. Der Ansatz liegt über dem in der städtischen Stellplatzsatzung geregelten Mindestwert von 1,0 und trägt dem Umstand Rechnung, dass das Plangebiet nicht an den Schienenpersonennahverkehr angebunden ist. Eine Reduzierung auf 1,2 Stellplätze wäre bei gleichzeitiger Festsetzung von Mobilitätsangeboten grundsätzlich vertretbar, wird von der Verwaltung derzeit aber nicht empfohlen.",
      },
      {
        id: "d184-11",
        art: "absatz",
        seite: 3,
        text: "Die nächstgelegene Bushaltestelle „Mühlenweg“ wird im Zuge der Erschließung barrierefrei ausgebaut. Eine Taktverdichtung der Linie 412 ist mit dem Verkehrsverbund abzustimmen und derzeit nicht zugesagt.",
      },
      { id: "d184-12", art: "ueberschrift", seite: 3, text: "Umweltbelange" },
      {
        id: "d184-13",
        art: "absatz",
        seite: 3,
        text: "Der Umweltbericht kommt zu dem Ergebnis, dass erhebliche Beeinträchtigungen des Schutzguts Klima zu erwarten sind. Der östliche Teil des Plangebiets liegt in einer Kaltluftentstehungsfläche, die über den Mühlenweg in den Siedlungskörper wirkt. Um die Kaltluftbahn zu erhalten, ist entlang der östlichen Plangebietsgrenze ein 25 Meter breiter Grünstreifen von Bebauung freizuhalten.",
      },
      {
        id: "d184-14",
        art: "absatz",
        seite: 4,
        text: "Die artenschutzrechtliche Prüfung weist zwei Brutreviere der Feldlerche im südlichen Plangebiet nach. Als vorgezogene Ausgleichsmaßnahme sind vor Baubeginn zwei Lerchenfenster auf der städtischen Fläche Gemarkung Ellernbach, Flur 12, Flurstück 84 anzulegen und dauerhaft zu unterhalten.",
      },
      {
        id: "d184-15",
        art: "absatz",
        seite: 4,
        text: "Der naturschutzrechtliche Ausgleichsbedarf beträgt 18.400 Ökopunkte und wird vollständig über das städtische Ökokonto gedeckt. Ein zusätzlicher Flächenerwerb ist nicht erforderlich.",
      },
      { id: "d184-16", art: "ueberschrift", seite: 4, text: "Entwässerung und Starkregenvorsorge" },
      {
        id: "d184-17",
        art: "absatz",
        seite: 4,
        text: "Das anfallende Niederschlagswasser wird im Plangebiet zurückgehalten und gedrosselt in den Mühlenbach eingeleitet. Vorgesehen sind ein Regenrückhaltebecken mit 1.150 Kubikmetern Stauraum sowie begrünte Mulden entlang der Erschließungsstraßen. Die Drosselabflussmenge beträgt 12 Liter je Sekunde.",
      },
      {
        id: "d184-18",
        art: "absatz",
        seite: 5,
        text: "Die Starkregengefahrenkarte weist für den nordwestlichen Randbereich des Plangebiets einen Fließweg aus. Die Erdgeschossfußbodenhöhen sind dort mindestens 30 Zentimeter über der angrenzenden Straßenoberkante festzusetzen. Keller sind wasserdicht auszubilden.",
      },
      { id: "d184-19", art: "ueberschrift", seite: 5, text: "Soziale Infrastruktur" },
      {
        id: "d184-20",
        art: "absatz",
        seite: 5,
        text: "Bei vollständiger Umsetzung ist mit rund 40 zusätzlichen Kindern im Alter bis sechs Jahre zu rechnen. Der Bedarf entspricht etwa zwei Kindergartengruppen. Die Kindertagesstätte Mühlenweg verfügt derzeit über keine freien Kapazitäten. Die Verwaltung prüft eine Erweiterung am bestehenden Standort; ein Ergebnis liegt zum Zeitpunkt der Vorlagenerstellung nicht vor.",
      },
      {
        id: "d184-21",
        art: "absatz",
        seite: 5,
        text: "Die Grundschule Nord kann den zu erwartenden Zuwachs von rund 25 Schulkindern nach Abschluss der laufenden Sanierung aufnehmen.",
      },
      { id: "d184-22", art: "ueberschrift", seite: 6, text: "Finanzielle Auswirkungen" },
      {
        id: "d184-23",
        art: "absatz",
        seite: 6,
        text: "Die Kosten der inneren Erschließung trägt der Vorhabenträger vollständig auf Grundlage eines städtebaulichen Vertrags. Der Stadt verbleiben Kosten für den barrierefreien Ausbau der Bushaltestelle in Höhe von rund 95.000 Euro sowie für die Herstellung der Ausgleichsmaßnahmen in Höhe von rund 40.000 Euro. Mittel stehen im Haushalt 2027, Produktkonto 511001, zur Verfügung.",
      },
      { id: "d184-24", art: "ueberschrift", seite: 6, text: "Beteiligung und weiteres Verfahren" },
      {
        id: "d184-25",
        art: "absatz",
        seite: 6,
        text: "Die frühzeitige Beteiligung der Öffentlichkeit nach § 3 Absatz 1 Baugesetzbuch fand vom 3. bis 24. Februar 2026 statt. Eingegangen sind 34 Stellungnahmen, überwiegend zur Verkehrsbelastung des Mühlenwegs und zum Verlust der freien Sicht auf die Feldflur. Die Abwägung ist in Anlage 2, Kapitel 7, dargestellt.",
      },
      {
        id: "d184-26",
        art: "absatz",
        seite: 6,
        text: "Nach Abschluss der Auslegung und Auswertung der Stellungnahmen ist der Satzungsbeschluss für das vierte Quartal 2026 vorgesehen.",
      },
    ],
  },

  "datei-195": {
    id: "datei-195",
    vorlageId: "vl-195",
    seitenzahl: 18,
    seitenImText: 4,
    anlagenhinweis:
      "Seiten 5–18: Anlage 1 Satzungstext in Gegenüberstellung, Anlage 2 Berechnungsgrundlagen. In diesem Prototyp nicht hinterlegt.",
    absaetze: [
      { id: "d195-01", art: "ueberschrift", seite: 1, text: "Beschlussvorschlag" },
      {
        id: "d195-02",
        art: "absatz",
        seite: 1,
        text: "Der Bau- und Umweltausschuss empfiehlt dem Rat, die 5. Satzung zur Änderung der Satzung über die Erhebung von Elternbeiträgen für die Inanspruchnahme von Angeboten der Kindertagesbetreuung in der Stadt Ellernbach in der als Anlage 1 beigefügten Fassung zu beschließen.",
      },
      { id: "d195-03", art: "ueberschrift", seite: 1, text: "Sachverhalt" },
      {
        id: "d195-04",
        art: "absatz",
        seite: 1,
        text: "Die geltende Elternbeitragssatzung sieht vor, dass für das zweite und jedes weitere gleichzeitig betreute Kind einer Familie kein Elternbeitrag erhoben wird. Voraussetzung ist, dass sich beide Kinder in einer Einrichtung im Stadtgebiet befinden. Diese Einschränkung führt in der Praxis wiederholt zu Härtefällen, wenn ein Geschwisterkind eine Einrichtung in einer Nachbarkommune besucht, etwa wegen eines heilpädagogischen Angebots.",
      },
      {
        id: "d195-05",
        art: "absatz",
        seite: 2,
        text: "Die Verwaltung schlägt vor, die Ortsbindung zu streichen. Die Geschwisterermäßigung soll künftig unabhängig davon gewährt werden, in welcher Kommune das zweite Kind betreut wird. Maßgeblich bleibt der Hauptwohnsitz der Familie in Ellernbach.",
      },
      {
        id: "d195-06",
        art: "absatz",
        seite: 2,
        text: "Zugleich soll die Beitragsstaffel um zwei Einkommensstufen erweitert werden. Die neue unterste Stufe bis 25.000 Euro Jahreseinkommen bleibt beitragsfrei. Die neue oberste Stufe ab 110.000 Euro Jahreseinkommen sieht einen Beitrag von 412 Euro monatlich für die 45-Stunden-Betreuung vor.",
      },
      { id: "d195-07", art: "ueberschrift", seite: 3, text: "Finanzielle Auswirkungen" },
      {
        id: "d195-08",
        art: "absatz",
        seite: 3,
        text: "Die Streichung der Ortsbindung betrifft nach aktueller Auswertung 23 Familien. Die Mindereinnahmen belaufen sich auf rund 68.000 Euro jährlich. Die Erweiterung der Beitragsstaffel nach oben führt zu Mehreinnahmen von rund 91.000 Euro jährlich. Insgesamt ergibt sich ein Überschuss von rund 23.000 Euro.",
      },
      {
        id: "d195-09",
        art: "absatz",
        seite: 3,
        text: "Die Elternbeitragsquote steigt damit von 17,4 auf 17,9 Prozent der Betriebskosten und bleibt unterhalb der landesrechtlich zulässigen Obergrenze von 19 Prozent.",
      },
      { id: "d195-10", art: "ueberschrift", seite: 4, text: "Beteiligung" },
      {
        id: "d195-11",
        art: "absatz",
        seite: 4,
        text: "Der Jugendhilfeausschuss hat der Änderung in seiner Sitzung am 18. Juni 2026 einstimmig zugestimmt. Der Stadtelternrat wurde beteiligt und begrüßt die Streichung der Ortsbindung, kritisiert jedoch die Höhe der neuen obersten Beitragsstufe.",
      },
      {
        id: "d195-12",
        art: "absatz",
        seite: 4,
        text: "Die Satzungsänderung soll zum Beginn des Kindergartenjahres am 1. August 2027 in Kraft treten.",
      },
    ],
  },

  "datei-033": {
    id: "datei-033",
    vorlageId: "vl-033",
    seitenzahl: 2,
    seitenImText: 2,
    anlagenhinweis: null,
    absaetze: [
      { id: "d033-01", art: "ueberschrift", seite: 1, text: "Antrag" },
      {
        id: "d033-02",
        art: "absatz",
        seite: 1,
        text: "Die Fraktion Bürgerforum beantragt, der Bau- und Umweltausschuss möge beschließen: Die Verwaltung wird beauftragt, für sämtliche Straßenabschnitte vor Kindertagesstätten und Grundschulen im Stadtgebiet die Anordnung von Tempo 30 zu prüfen und die Anordnung dort umzusetzen, wo die straßenverkehrsrechtlichen Voraussetzungen vorliegen.",
      },
      {
        id: "d033-03",
        art: "absatz",
        seite: 1,
        text: "Die Prüfung ist bis zum 31. Dezember 2026 abzuschließen. Dem Ausschuss ist eine Liste der geprüften Abschnitte mit dem jeweiligen Ergebnis vorzulegen.",
      },
      { id: "d033-04", art: "ueberschrift", seite: 1, text: "Begründung" },
      {
        id: "d033-05",
        art: "absatz",
        seite: 1,
        text: "Seit der Novelle der Allgemeinen Verwaltungsvorschrift zur Straßenverkehrs-Ordnung können Kommunen Tempo 30 vor Kindertagesstätten und Schulen ohne gesonderten Gefahrennachweis anordnen. Von dieser Möglichkeit hat die Stadt Ellernbach bislang nur an vier Standorten Gebrauch gemacht.",
      },
      {
        id: "d033-06",
        art: "absatz",
        seite: 2,
        text: "An mindestens sieben weiteren Standorten queren Kinder täglich Straßen mit einer zulässigen Höchstgeschwindigkeit von 50 Kilometern je Stunde, darunter die Bahnhofstraße vor der Kindertagesstätte Sonnenblume und die Lindenallee vor der Grundschule Süd. Eltern und Einrichtungsleitungen haben sich in beiden Fällen schriftlich an die Fraktion gewandt.",
      },
      {
        id: "d033-07",
        art: "absatz",
        seite: 2,
        text: "Der Anhalteweg verkürzt sich bei einer Reduzierung von 50 auf 30 Kilometer je Stunde von rund 28 auf rund 13 Meter. Die Maßnahme ist mit vergleichsweise geringem Aufwand umsetzbar und erfordert im Wesentlichen die Beschaffung und Aufstellung von Verkehrszeichen.",
      },
    ],
  },

  "datei-188": {
    id: "datei-188",
    vorlageId: "vl-188",
    seitenzahl: 3,
    seitenImText: 3,
    anlagenhinweis: null,
    absaetze: [
      { id: "d188-01", art: "ueberschrift", seite: 1, text: "Stellungnahme der Verwaltung" },
      {
        id: "d188-02",
        art: "absatz",
        seite: 1,
        text: "Zum Antrag A/2026/033 der Fraktion Bürgerforum nimmt die Verwaltung wie folgt Stellung.",
      },
      {
        id: "d188-03",
        art: "absatz",
        seite: 1,
        text: "Das Anliegen wird dem Grunde nach unterstützt. Die Verwaltung weist darauf hin, dass die vereinfachte Anordnung nach der genannten Verwaltungsvorschrift räumlich eng begrenzt ist. Sie gilt für den unmittelbaren Bereich vor der jeweiligen Einrichtung, in der Regel für einen Abschnitt von rund 300 Metern. Eine flächenhafte Ausweitung auf ganze Straßenzüge ist auf dieser Grundlage nicht möglich.",
      },
      {
        id: "d188-04",
        art: "absatz",
        seite: 2,
        text: "Für die Bahnhofstraße ist zu berücksichtigen, dass es sich um eine Vorbehaltsstraße mit überörtlicher Verbindungsfunktion handelt. Die Zustimmung der Straßenverkehrsbehörde des Kreises ist hier erforderlich und nach bisheriger Praxis nicht sicher zu erwarten.",
      },
      {
        id: "d188-05",
        art: "absatz",
        seite: 2,
        text: "Für die Lindenallee vor der Grundschule Süd bestehen aus Sicht der Verwaltung keine Bedenken. Die Anordnung könnte kurzfristig erfolgen.",
      },
      { id: "d188-06", art: "ueberschrift", seite: 2, text: "Aufwand" },
      {
        id: "d188-07",
        art: "absatz",
        seite: 2,
        text: "Die Prüfung sämtlicher in Betracht kommender Standorte bindet im Fachbereich Tiefbau und Verkehr etwa 25 Personentage. Bei gleichbleibender Personalausstattung ist ein Abschluss bis zum 31. Dezember 2026 nicht darstellbar. Die Verwaltung regt an, die Frist auf den 30. Juni 2027 zu verlängern.",
      },
      {
        id: "d188-08",
        art: "absatz",
        seite: 3,
        text: "Die Kosten für Beschilderung und Markierung betragen je Standort rund 2.400 Euro. Mittel sind im laufenden Haushalt nicht eingeplant und wären im Rahmen der Haushaltsberatungen 2027 anzumelden.",
      },
    ],
  },

  "datei-176": {
    id: "datei-176",
    vorlageId: "vl-176",
    seitenzahl: 64,
    seitenImText: 4,
    anlagenhinweis:
      "Seiten 5–64: Anlage 1 Maßnahmenkatalog, Anlage 2 Netzkarte, Anlage 3 Kostenschätzung. In diesem Prototyp nicht hinterlegt.",
    absaetze: [
      { id: "d176-01", art: "ueberschrift", seite: 1, text: "Beschlussvorschlag" },
      {
        id: "d176-02",
        art: "absatz",
        seite: 1,
        text: "Der Bau- und Umweltausschuss nimmt die Fortschreibung des Radverkehrskonzepts 2027 zur Kenntnis und empfiehlt dem Rat, den Maßnahmenkatalog nach Anlage 1 als Grundlage für die weitere Planung zu beschließen.",
      },
      { id: "d176-03", art: "ueberschrift", seite: 1, text: "Sachverhalt" },
      {
        id: "d176-04",
        art: "absatz",
        seite: 1,
        text: "Das Radverkehrskonzept der Stadt Ellernbach stammt aus dem Jahr 2016 und ist in weiten Teilen abgearbeitet. Von 41 Maßnahmen sind 27 vollständig und 6 teilweise umgesetzt. Die Fortschreibung führt die verbliebenen Maßnahmen fort und ergänzt sie um 22 neue.",
      },
      {
        id: "d176-05",
        art: "absatz",
        seite: 2,
        text: "Schwerpunkt der Fortschreibung ist die Schließung von Netzlücken zwischen den Ortsteilen. Als vordringlich eingestuft sind die Verbindung Ellernbach–Warkenbrück entlang der Kreisstraße 14 sowie die Querung der Bahnstrecke am Bahnhof, die derzeit nur über die Treppenanlage möglich ist.",
      },
      {
        id: "d176-06",
        art: "absatz",
        seite: 2,
        text: "Neu aufgenommen wurde das Ziel, an allen weiterführenden Schulen und am Bahnhof überdachte und diebstahlsichere Abstellanlagen einzurichten. Der Bedarf wird mit insgesamt 640 Stellplätzen beziffert.",
      },
      { id: "d176-07", art: "ueberschrift", seite: 3, text: "Kosten und Förderung" },
      {
        id: "d176-08",
        art: "absatz",
        seite: 3,
        text: "Die Gesamtkosten aller Maßnahmen belaufen sich auf rund 6,8 Millionen Euro über einen Zeitraum von zehn Jahren. Für die vordringlichen Maßnahmen der ersten Stufe werden 2,1 Millionen Euro veranschlagt. Eine Förderung von bis zu 75 Prozent über das Landesprogramm Nahmobilität erscheint möglich, ist jedoch antragsgebunden und nicht zugesagt.",
      },
      {
        id: "d176-09",
        art: "absatz",
        seite: 4,
        text: "Für die Erstellung der Fortschreibung wurde das Büro Radwerk Ingenieure beauftragt. Die Bürgerbeteiligung erfolgte über eine Online-Mängelkarte, an der sich 312 Personen mit insgesamt 890 Hinweisen beteiligt haben.",
      },
    ],
  },

  "datei-191": {
    id: "datei-191",
    vorlageId: "vl-191",
    seitenzahl: 12,
    seitenImText: 3,
    nichtoeffentlich: true,
    anlagenhinweis:
      "Seiten 4–12: Anlage 1 Submissionsergebnis, Anlage 2 Wertungsübersicht. In diesem Prototyp nicht hinterlegt.",
    absaetze: [
      { id: "d191-01", art: "ueberschrift", seite: 1, text: "Beschlussvorschlag" },
      {
        id: "d191-02",
        art: "absatz",
        seite: 1,
        text: "Der Bau- und Umweltausschuss beschließt, den Auftrag für Los 2 – Rohbauarbeiten im Rahmen der Sanierung der Grundschule Nord an das wirtschaftlichste Angebot zu vergeben.",
      },
      { id: "d191-03", art: "ueberschrift", seite: 1, text: "Sachverhalt" },
      {
        id: "d191-04",
        art: "absatz",
        seite: 1,
        text: "Die Rohbauarbeiten wurden europaweit im offenen Verfahren ausgeschrieben. Bis zum Submissionstermin am 26. Juni 2026 sind fünf Angebote eingegangen. Zwei Angebote waren aus formalen Gründen von der Wertung auszuschließen.",
      },
      {
        id: "d191-05",
        art: "absatz",
        seite: 2,
        text: "Das wirtschaftlichste wertbare Angebot liegt rund 14 Prozent über der Kostenberechnung des Architekturbüros. Die Abweichung wird auf die weiterhin angespannte Marktlage bei Betonfertigteilen zurückgeführt. Eine Aufhebung der Ausschreibung und Neuvergabe würde den Fertigstellungstermin um mindestens ein Schuljahr verschieben.",
      },
      { id: "d191-06", art: "ueberschrift", seite: 3, text: "Finanzielle Auswirkungen" },
      {
        id: "d191-07",
        art: "absatz",
        seite: 3,
        text: "Die Mehrkosten gegenüber der Kostenberechnung betragen rund 310.000 Euro. Eine Deckung ist durch Umschichtung innerhalb der Gesamtmaßnahme möglich; der Kostenrahmen des Ratsbeschlusses vom 14. November 2025 wird eingehalten.",
      },
      {
        id: "d191-08",
        art: "hinweis",
        seite: 3,
        text: "Diese Vorlage wird im nichtöffentlichen Teil der Sitzung beraten, weil sie Angaben zu laufenden Vergabeverfahren und zu Angebotspreisen einzelner Bieter enthält.",
      },
    ],
  },

  /*
    Zweite Fassung des Bebauungsplans — die Verwaltung hat nachgetauscht.

    Der Text ist bewusst nah an der ersten Fassung gehalten, mit wenigen, aber
    inhaltlich schweren Änderungen: Der Stellplatzschlüssel sinkt von 1,5 auf
    1,2, der Grünstreifen wächst von 25 auf 30 Meter, und die Kita-Erweiterung
    ist inzwischen geklärt. Genau das hatte die Fraktion in der ersten Fassung
    markiert und im Chat besprochen.

    WICHTIG: Eigene Absatz-Kennungen (d184b-…). Würden die Kennungen der ersten
    Fassung wiederverwendet, wanderten die alten Markierungen stillschweigend
    in den neuen Text — an Stellen, die dort etwas anderes sagen.
  */
  "datei-184-2": {
    id: "datei-184-2",
    vorlageId: "vl-184-2",
    seitenzahl: 44,
    seitenImText: 6,
    anlagenhinweis:
      "Seiten 7–44: Anlage 1 Planzeichnung (geändert), Anlage 2 Begründung, Anlage 3 Umweltbericht, Anlage 4 Gegenüberstellung der Fassungen. In diesem Prototyp nicht hinterlegt.",
    absaetze: [
      {
        id: "d184b-00",
        art: "hinweis",
        seite: 1,
        text: "Diese Vorlage ersetzt die Fassung vom 12. Juni 2026. Geändert wurden der Stellplatzschlüssel, die Breite des Grünstreifens an der östlichen Plangebietsgrenze sowie die Angaben zur Kindertagesbetreuung. Eine Gegenüberstellung beider Fassungen ist als Anlage 4 beigefügt.",
      },
      { id: "d184b-01", art: "ueberschrift", seite: 1, text: "Beschlussvorschlag" },
      {
        id: "d184b-02",
        art: "absatz",
        seite: 1,
        text: "Der Bau- und Umweltausschuss beschließt, den Entwurf des Bebauungsplans Nr. 47 „Am Mühlenweg“ in der Fassung vom 21. Juli 2026 einschließlich Begründung und Umweltbericht gemäß § 3 Absatz 2 Baugesetzbuch für die Dauer eines Monats öffentlich auszulegen. Ort und Dauer der Auslegung sind ortsüblich bekannt zu machen.",
      },
      {
        id: "d184b-03",
        art: "absatz",
        seite: 1,
        text: "Die Verwaltung wird beauftragt, parallel die Stellungnahmen der Behörden und sonstigen Träger öffentlicher Belange nach § 4 Absatz 2 Baugesetzbuch einzuholen.",
      },
      { id: "d184b-04", art: "ueberschrift", seite: 1, text: "Sachverhalt" },
      {
        id: "d184b-05",
        art: "absatz",
        seite: 1,
        text: "Das Plangebiet umfasst rund 4,2 Hektar am östlichen Ortsrand und wird begrenzt durch den Mühlenweg im Norden, die Feldstraße im Westen und die Bahnstrecke Ellernbach–Warkenbrück im Süden. Die Flächen werden derzeit überwiegend landwirtschaftlich genutzt. Der Flächennutzungsplan stellt den Bereich bereits als Wohnbaufläche dar; der Bebauungsplan wird damit aus dem Flächennutzungsplan entwickelt.",
      },
      {
        id: "d184b-06",
        art: "absatz",
        seite: 2,
        text: "Vorgesehen ist die Festsetzung eines allgemeinen Wohngebiets nach § 4 Baunutzungsverordnung mit rund 85 Wohneinheiten in Einzel-, Doppel- und Reihenhäusern sowie drei Mehrfamilienhäusern entlang der Feldstraße. Für die Mehrfamilienhäuser sind drei Vollgeschosse zulässig, für die übrige Bebauung zwei Vollgeschosse zuzüglich ausgebautem Dachgeschoss.",
      },
      {
        id: "d184b-07",
        art: "absatz",
        seite: 2,
        text: "Mindestens 30 Prozent der Wohnfläche in den Mehrfamilienhäusern sind für den öffentlich geförderten Wohnungsbau vorzusehen. Diese Quote wird über einen städtebaulichen Vertrag mit dem Vorhabenträger abgesichert und ist Voraussetzung für den Satzungsbeschluss.",
      },
      { id: "d184b-08", art: "ueberschrift", seite: 2, text: "Erschließung und ruhender Verkehr" },
      {
        id: "d184b-09",
        art: "absatz",
        seite: 2,
        text: "Die verkehrliche Erschließung erfolgt vollständig über den Mühlenweg. Das Verkehrsgutachten des Büros Prenzel + Partner vom 4. April 2026 prognostiziert für den Endausbau rund 420 zusätzliche Kraftfahrzeugfahrten je Werktag. Die vorhandene Knotenpunktleistungsfähigkeit an der Einmündung Mühlenweg / Bahnhofstraße bleibt danach auch in der Spitzenstunde ausreichend. Auf Anregung aus der Vorberatung wird an der Einmündung eine Dauerzählstelle eingerichtet.",
      },
      {
        id: "d184b-10",
        art: "absatz",
        seite: 3,
        text: "Für den ruhenden Verkehr wird ein Stellplatzschlüssel von 1,2 Stellplätzen je Wohneinheit festgesetzt. Die gegenüber der ersten Fassung verringerte Zahl wird durch verbindliche Mobilitätsangebote ausgeglichen: zwei Stellplätze für stationsgebundenes Carsharing, überdachte Fahrradabstellanlagen mit mindestens zwei Plätzen je Wohneinheit sowie Ladeinfrastruktur an einem Viertel der Stellplätze. Die Angebote werden im städtebaulichen Vertrag festgeschrieben.",
      },
      {
        id: "d184b-11",
        art: "absatz",
        seite: 3,
        text: "Die nächstgelegene Bushaltestelle „Mühlenweg“ wird im Zuge der Erschließung barrierefrei ausgebaut. Für eine Taktverdichtung der Linie 412 auf einen Halbstundentakt liegt inzwischen eine Absichtserklärung des Verkehrsverbunds vor; die Finanzierung ist noch nicht abschließend geklärt.",
      },
      { id: "d184b-12", art: "ueberschrift", seite: 3, text: "Umweltbelange" },
      {
        id: "d184b-13",
        art: "absatz",
        seite: 3,
        text: "Der Umweltbericht kommt zu dem Ergebnis, dass erhebliche Beeinträchtigungen des Schutzguts Klima zu erwarten sind. Der östliche Teil des Plangebiets liegt in einer Kaltluftentstehungsfläche, die über den Mühlenweg in den Siedlungskörper wirkt. Um die Kaltluftbahn zu erhalten, ist entlang der östlichen Plangebietsgrenze ein 30 Meter breiter Grünstreifen von Bebauung freizuhalten. Die Verbreiterung um fünf Meter gegenüber der ersten Fassung geht auf eine ergänzende Kaltluftsimulation zurück.",
      },
      {
        id: "d184b-14",
        art: "absatz",
        seite: 4,
        text: "Die artenschutzrechtliche Prüfung weist zwei Brutreviere der Feldlerche im südlichen Plangebiet nach. Als vorgezogene Ausgleichsmaßnahme sind vor Baubeginn zwei Lerchenfenster auf der städtischen Fläche Gemarkung Ellernbach, Flur 12, Flurstück 84 anzulegen und dauerhaft zu unterhalten.",
      },
      {
        id: "d184b-15",
        art: "absatz",
        seite: 4,
        text: "Der naturschutzrechtliche Ausgleichsbedarf beträgt nunmehr 17.100 Ökopunkte und wird vollständig über das städtische Ökokonto gedeckt. Der geringere Bedarf ergibt sich aus dem verbreiterten Grünstreifen. Ein zusätzlicher Flächenerwerb ist nicht erforderlich.",
      },
      { id: "d184b-16", art: "ueberschrift", seite: 4, text: "Entwässerung und Starkregenvorsorge" },
      {
        id: "d184b-17",
        art: "absatz",
        seite: 4,
        text: "Das anfallende Niederschlagswasser wird im Plangebiet zurückgehalten und gedrosselt in den Mühlenbach eingeleitet. Vorgesehen sind ein Regenrückhaltebecken mit 1.150 Kubikmetern Stauraum sowie begrünte Mulden entlang der Erschließungsstraßen. Die Drosselabflussmenge beträgt 12 Liter je Sekunde.",
      },
      {
        id: "d184b-18",
        art: "absatz",
        seite: 5,
        text: "Die Starkregengefahrenkarte weist für den nordwestlichen Randbereich des Plangebiets einen Fließweg aus. Die Erdgeschossfußbodenhöhen sind dort mindestens 30 Zentimeter über der angrenzenden Straßenoberkante festzusetzen. Keller sind wasserdicht auszubilden.",
      },
      { id: "d184b-19", art: "ueberschrift", seite: 5, text: "Soziale Infrastruktur" },
      {
        id: "d184b-20",
        art: "absatz",
        seite: 5,
        text: "Bei vollständiger Umsetzung ist mit rund 40 zusätzlichen Kindern im Alter bis sechs Jahre zu rechnen. Der Bedarf entspricht etwa zwei Kindergartengruppen. Die Erweiterung der Kindertagesstätte Mühlenweg um zwei Gruppen am bestehenden Standort ist inzwischen geprüft und baulich möglich. Die Mittel sind in der mittelfristigen Finanzplanung ab 2028 veranschlagt.",
      },
      {
        id: "d184b-21",
        art: "absatz",
        seite: 5,
        text: "Die Grundschule Nord kann den zu erwartenden Zuwachs von rund 25 Schulkindern nach Abschluss der laufenden Sanierung aufnehmen.",
      },
      { id: "d184b-22", art: "ueberschrift", seite: 6, text: "Finanzielle Auswirkungen" },
      {
        id: "d184b-23",
        art: "absatz",
        seite: 6,
        text: "Die Kosten der inneren Erschließung trägt der Vorhabenträger vollständig auf Grundlage eines städtebaulichen Vertrags. Der Stadt verbleiben Kosten für den barrierefreien Ausbau der Bushaltestelle in Höhe von rund 95.000 Euro sowie für die Herstellung der Ausgleichsmaßnahmen in Höhe von rund 40.000 Euro. Für die Erweiterung der Kindertagesstätte sind nach erster Schätzung 1,4 Millionen Euro anzusetzen. Mittel stehen im Haushalt 2027, Produktkonto 511001, zur Verfügung.",
      },
      { id: "d184b-24", art: "ueberschrift", seite: 6, text: "Beteiligung und weiteres Verfahren" },
      {
        id: "d184b-25",
        art: "absatz",
        seite: 6,
        text: "Die frühzeitige Beteiligung der Öffentlichkeit nach § 3 Absatz 1 Baugesetzbuch fand vom 3. bis 24. Februar 2026 statt. Eingegangen sind 34 Stellungnahmen, überwiegend zur Verkehrsbelastung des Mühlenwegs und zum Verlust der freien Sicht auf die Feldflur. Die Abwägung ist in Anlage 2, Kapitel 7, dargestellt.",
      },
      {
        id: "d184b-26",
        art: "absatz",
        seite: 6,
        text: "Nach Abschluss der Auslegung und Auswertung der Stellungnahmen ist der Satzungsbeschluss für das erste Quartal 2027 vorgesehen. Die Verschiebung um ein Quartal gegenüber der ersten Fassung ergibt sich aus der erneuten Beteiligung der Träger öffentlicher Belange.",
      },
    ],
  },
};
